import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-twenty-two',
  templateUrl: './home-twenty-two.component.html',
  styleUrls: ['./home-twenty-two.component.scss']
})
export class HomeTwentyTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
